import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import Link from 'components/link';

const RelatedPagesDescriptionBlock = ({ items }) => {
  const allItemsHaveImages = items?.every(item => item?.image) ?? false;

  return (
    <div className="related-pages-description-block">
      {items?.length > 0 && (
        <div className="related-pages-description-block__items">
          {items.map(item => (
            <div
              className="related-pages-description-block__item"
              key={item?.link.text}
            >
              {item.image && allItemsHaveImages && (
                <div className="related-pages-description-block__item-image-container">
                  <Image theme={Image.themes.background} {...item.image} />
                </div>
              )}
              <div className="related-pages-description-block__item-link-container">
                <Link
                  className="link--in-related-pages"
                  animation="shrink"
                  {...item.link}
                />
              </div>
              {item.description && (
                <div className="related-pages-description-block__item-description">
                  {item.description}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

RelatedPagesDescriptionBlock.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.exact(Link.propTypes),
      image: PropTypes.exact(Image.propTypes),
      description: PropTypes.string
    })
  )
};

RelatedPagesDescriptionBlock.defaultProps = {
  items: []
};

export default RelatedPagesDescriptionBlock;
